<template>
  <div>
    <section
      v-if="membershipGroups.data.length"
      class="flex flex-wrap items-stretch"
    >
      <div
        v-for="membershipGroup in membershipGroups.data"
        :key="`membership-group-${membershipGroup.uuid}`"
        class="flex w-full sm:w-1/2 md:w-1/3 lg:w-1/4 xl:w-1/5 min-w-card"
      >
        <div class="card card-bio-content card--interactive text-center">
          <h6
            class="text-blue uppercase -mt-2 mb-4"
            v-text="membershipGroup.attributes.type"
          />
          <h2
            class="mb-1"
            v-text="membershipGroup.attributes.title"
          />
          <h5
            class="mt-0 mb-4 uppercase"
            v-text="membershipGroupCount(membershipGroup.attributes.membership_count)"
          />
          <button
            type="button"
            class="btn btn--border btn--sm btn--danger"
            @click.prevent="confirmRemoval(membershipGroup)"
            v-text="'Remove from group'"
          />
        </div>
      </div>
      <div class="text-grey text-center mt-4">
        You may visit the <a href="/members/membership-groups">groups</a> section to add members to groups.
      </div>
    </section>
    <section
      v-else
      class="empty"
    >
      <section>
        <h2 v-text="'This member is not part of any groups'" />
        <p>You may visit the <a href="/members/membership-groups">groups</a> section to add members to groups.</p>
      </section>
    </section>
    <RemoveMembershipFromMembershipGroupModal @membershipHasBeenRemovedFromMembershipGroup="membershipHasBeenRemovedFromMembershipGroup" />
  </div>
</template>

<script type="text/babel">
import RemoveMembershipFromMembershipGroupModal from './_modals/RemoveMembershipFromMembershipGroupModal'

export default {
  name: 'MembershipGroups',
  components: {
    RemoveMembershipFromMembershipGroupModal,
  },
  props: {
    membershipUuid: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      membershipGroups: {
        data: [],
      },
    }
  },
  async mounted() {
    await this.$nextTick()

    if (this.membershipUuid) {
      this.fetch()
    }
  },
  methods: {
    membershipGroupCount(count) {
      return count === 1
        ? '1 member'
        : `${count} members`
    },
    fetch() {
      this.$api.active().get(`memberships/${this.membershipUuid}/membership-groups`)
        .then((response) => {
          this.membershipGroups = response.data
        })
    },
    confirmRemoval(membershipGroup) {
      this.$store.commit('membershipOpenRemoveMembershipFromMembershipGroupModal', {
        membershipUuid: this.membershipUuid,
        membershipGroup,
      })
    },
    membershipHasBeenRemovedFromMembershipGroup() {
      this.$store.commit('baseAddNotification', {
        type: 'success',
        text: 'Membership has been removed from group!',
      })

      this.fetch()
    },
  },
}
</script>
